var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.loading || _vm.tableData.length === 0)?_c('div',{staticClass:"flex flex-col justify-center items-center h-full mt-5"},[_c('el-empty',{attrs:{"image-size":70,"description":"No Data"}})],1):_c('div',{},[_c('ve-table',{attrs:{"columns":_vm.columns,"table-data":_vm.tableData}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }